import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ERROR } from '@/configs/constants';
import { ECOM_HEADER_DETAIL } from '@/configs/ecom/apis';
import { transformHeaderItems } from '@/utils';

export const getHeaderDetail = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(ECOM_HEADER_DETAIL), {
      params: {
        populate: 'nav.icon,profile.icon,featured.icon',
      },
    });
    const { attributes = {} } = response.data.data ?? {};
    const { nav, profile, featured } = attributes;

    return {
      nav: transformHeaderItems(nav),
      profile: transformHeaderItems(profile),
      featured: transformHeaderItems(featured),
    };
  } catch (error: any) {
    console.error(error?.message);
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
